import PropTypes from 'prop-types';

import { trackEvent } from 'dibs-tracking';
import { Link } from 'dibs-elements/exports/Link.tsx';

import styles from './ContemporaryLandingProductsModuleItem.scss';

const trackClick = () => {
    trackEvent({
        category: 'contemporary landing page interaction',
        action: 'featured items',
        label: 'featured item clicked',
        value: 0,
    });
};

export const ContemporaryLandingProductsModuleItem = ({ item }) => {
    const { imagePath, title, link } = item;

    return (
        <Link href={link} className={styles.item} onClick={() => trackClick(item)}>
            <div className={styles.imageWrapper}>
                <img className={styles.image} src={imagePath} alt={title} />
            </div>
            <div className={styles.title} dangerouslySetInnerHTML={{ __html: title }} />
        </Link>
    );
};

ContemporaryLandingProductsModuleItem.propTypes = {
    item: PropTypes.shape({
        title: PropTypes.string,
        imagePath: PropTypes.string,
        link: PropTypes.string,
    }).isRequired,
};
